// Kick off the JS chunk fetch for a route slightly before the user's
// click resolves. Fires on pointerdown (typically 80–120 ms earlier than
// the trailing click event); on browsers without pointer events, no
// prefetch happens and the click still works as before.
//
// Each prefetcher is a plain dynamic import — React.lazy() picks the
// module out of the module cache once import() resolves, so the next
// navigation is limited by React's Suspense render rather than by the
// network round-trip.

const PREFETCHERS: Record<string, () => Promise<unknown>> = {
  "/feedback": () => import("../pages/FeedbackPage"),
  "/billing": () => import("../pages/BillingPage"),
  "/account": () => import("../pages/AccountPage"),
  "/import": () => import("../pages/ImportPage"),
  "/admin": () => import("../pages/AdminPage"),
  "/privacy": () => import("../pages/PrivacyPage"),
  "/terms": () => import("../pages/TermsPage"),
  "/cookies": () => import("../pages/CookiesPage"),
  "/refunds": () => import("../pages/RefundsPage"),
  "/forgot-password": () => import("../pages/ForgotPasswordPage"),
  "/reset-password": () => import("../pages/ResetPasswordPage"),
  "/verify-email": () => import("../pages/VerifyEmailPage"),
};

const inFlight = new Set<string>();

export function prefetchRoute(href: string): void {
  // Direct match first (fast common case); fall back to prefix for nested
  // routes like /reset-password/xxx.
  let key: string | null = null;
  if (href in PREFETCHERS) key = href;
  else {
    for (const k of Object.keys(PREFETCHERS)) {
      if (href.startsWith(k + "/")) {
        key = k;
        break;
      }
    }
  }
  if (!key || inFlight.has(key)) return;
  inFlight.add(key);
  PREFETCHERS[key]().catch(() => {
    // If the fetch itself fails, drop the guard so a real click gets to
    // retry rather than silently sitting on the first-failure state.
    inFlight.delete(key);
  });
}
